import { IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { LuBell, LuBellOff, LuBellRing } from 'react-icons/lu';
import { usePushNotifications } from '../usePushNotifications';

/* Top-bar bell that turns admin push notifications on/off. Hidden entirely
   when the browser can't do Web Push or no VAPID key is configured. */
export function NotificationsToggle() {
  const { t } = useTranslation();
  const { state, enable, disable } = usePushNotifications();

  if (state === 'unsupported') {
    return null;
  }

  if (state === 'denied') {
    return (
      <IconButton
        aria-label={t('notifications.blocked')}
        title={t('notifications.blocked')}
        variant="ghost"
        size="sm"
        disabled
      >
        <LuBellOff />
      </IconButton>
    );
  }

  const isOn = state === 'on';
  const label = isOn ? t('notifications.disable') : t('notifications.enable');
  return (
    <IconButton
      aria-label={label}
      title={label}
      variant="ghost"
      size="sm"
      loading={state === 'busy'}
      colorPalette={isOn ? 'teal' : undefined}
      onClick={() => {
        void (isOn ? disable() : enable());
      }}
    >
      {isOn ? <LuBellRing /> : <LuBell />}
    </IconButton>
  );
}
